import { Button, Dialog, Stack, Typography, Checkbox, MenuItem, ListItemText, Collapse } from '@mui/material';
import React, { useState } from 'react';
import { useCreateRecommendationBatchMutation } from '../../../../api/apiSlice';
import { theme } from '../../../../theme';


function CreateBatchDialog({ open, setOpen, hospitals = [] }) {
    const [selectedHospitals, setSelectedHospitals] = useState([]);
    const [advancedOptions, setAdvancedOptions] = useState({
        generate_stats: true,
        include_comparison: true
    });
    const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [createRecommendationBatch] = useCreateRecommendationBatchMutation();

    async function handleCreate() {
        setErrorMessage('');
        await createRecommendationBatch({ data: { 
            hospital_ids: selectedHospitals,
            generate_stats: advancedOptions.generate_stats,
            include_comparison: advancedOptions.include_comparison
        } }).unwrap().then(() => {
            setOpen(false);
            setSelectedHospitals([]);
        }).catch((error) => {
            setErrorMessage(error.data?.message || 'An error occurred while creating the recommendation batch.');
        });
    }

    return (
        <Dialog maxWidth='lg' open={open} onClose={() => setOpen(false)}>
            <Stack p={2} spacing={2}>
                <Typography variant='heavy'>Create New Recommendation Batch</Typography>
                <Stack spacing={2}>
                    <Stack direction='row' alignItems='center' justifyContent='space-between'>
                        <Typography>Select hospitals to begin recommendation generation at:</Typography>
                        <Button variant='contained' size='small' onClick={() => {
                            setSelectedHospitals(hospitals.map(hospital => hospital.id));
                        }}>Select All</Button>
                    </Stack>
                    <Stack spacing={1}>
                        { hospitals.map((hospital) => (
                            <MenuItem key={hospital.id} onClick={() => {
                                if (selectedHospitals.includes(hospital.id)) {
                                    setSelectedHospitals(selectedHospitals.filter(id => id !== hospital.id));
                                } else {
                                    setSelectedHospitals([...selectedHospitals, hospital.id]);
                                }
                            }}>
                                <Checkbox
                                    key={hospital.id}
                                    checked={selectedHospitals.includes(hospital.id)}
                                />
                                <ListItemText primary={hospital.name} />
                            </MenuItem>
                        )) }
                    </Stack>
                    <Button
                        variant='text'
                        type='button'
                        sx={{ cursor: 'pointer', color: 'blue' }}
                        onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
                    >
                        { showAdvancedOptions ? 'Hide' : 'Show' } Advanced Options
                    </Button>
                    <Collapse in={showAdvancedOptions}>
                        <Stack spacing={1}>
                            <Typography variant='light' color={theme.palette.subtext.main}>Note: These options are available to remove steps from the rec generation process for use in rare cases. Use with caution as they may have unintended consequences on the final results.</Typography>
                            <Stack direction='row' alignItems='center' justifyContent='space-between'>
                                <Typography>Generate Stats</Typography>
                                <Checkbox
                                    checked={advancedOptions.generate_stats}
                                    onChange={(e) => setAdvancedOptions(prev => ({ ...prev, generate_stats: e.target.checked }))}
                                />
                            </Stack>
                            <Stack direction='row' alignItems='center' justifyContent='space-between'>
                                <Typography>Include Comparison</Typography>
                                <Checkbox
                                    checked={advancedOptions.include_comparison}
                                    onChange={(e) => setAdvancedOptions(prev => ({ ...prev, include_comparison: e.target.checked }))}
                                />
                            </Stack>
                        </Stack>
                    </Collapse>
                </Stack>
                { errorMessage && (
                    <Typography color='error'>
                        {errorMessage}
                    </Typography>
                ) }
                <Stack direction='row' spacing={2} justifyContent='flex-end'>
                    <Button variant='contained' onClick={() => setOpen(false)}>Close</Button>
                    <Button variant='contained' color='primary' disabled={selectedHospitals.length === 0} onClick={handleCreate}>
                        Create Batch
                    </Button>
                </Stack>
            </Stack>
        </Dialog>
    );
}

export default CreateBatchDialog;

